import { render } from "./XIcon.vue?vue&type=template&id=6ce9cd8f"
import script from "./XIcon.vue?vue&type=script&lang=js"
export * from "./XIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIcon.vue"]])

export default __exports__